import { render, staticRenderFns } from "./OrderAffiliateTable.vue?vue&type=template&id=553f09d1&scoped=true"
import script from "./OrderAffiliateTable.vue?vue&type=script&lang=js"
export * from "./OrderAffiliateTable.vue?vue&type=script&lang=js"
import style0 from "./OrderAffiliateTable.vue?vue&type=style&index=0&id=553f09d1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "553f09d1",
  null
  
)

export default component.exports